import {httpGet,httpPut,httpDelete,httpPost} from '../../../util/request.js';
import appConfig from '../../../config';

export default class AppointApi{

	static QUERY_APPOINT_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/org/appoints";
	static STOP_APPOINT_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/org/appoint/stop";
	static RESTORE_APPOINT_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/org/appoint/restore";
	static INSERT_APPOINT_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/org/appoint";
	
	static queryAppoint(params){
		return httpGet(AppointApi.QUERY_APPOINT_API_URL,params);
	}

	static stopAppoint(appoint){
		let params={appoint:appoint};
		return httpPost(AppointApi.STOP_APPOINT_API_URL,params);
	}

	static restoreAppoint(appoint){
		let params={appoint:appoint};
		return httpPost(AppointApi.RESTORE_APPOINT_API_URL,params);
	}
	
	static insertAppoint(appoint){
		let params={appoint:appoint};
		return httpPost(AppointApi.INSERT_APPOINT_API_URL,params);
	}
	

	
}